import { Typography } from '@mui/material';
import React, { Fragment, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { FormControls, FormikArray, FormikNumericField } from 'components';
import { TranslationNamespace } from 'i18n';

export const PayinBlockAmounts: React.FC = () => {
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'features.shops.manage',
  });

  const renderItemComponent = useCallback(
    ({ index }: { index: number }) => (
      <FormControls sx={{ flex: 1 }}>
        <FormControls row>
          <FormikNumericField
            label={t('sections.block_amounts.fields.period')}
            name={`payinBlockAmountConfigs[${index}].period`}
            fullWidth
            required
            decimalScale={0}
            allowNegative={false}
          />
          <FormikNumericField
            label={t('sections.block_amounts.fields.count')}
            name={`payinBlockAmountConfigs[${index}].count`}
            fullWidth
            required
            decimalScale={0}
            allowNegative={false}
          />
        </FormControls>
        <FormikNumericField
          label={t('sections.block_amounts.fields.duration')}
          name={`payinBlockAmountConfigs[${index}].duration`}
          fullWidth
          required
          decimalScale={0}
          allowNegative={false}
        />
      </FormControls>
    ),
    [t],
  );

  return (
    <Fragment>
      <Typography variant="subtitle1">
        {t('sections.block_amounts.title')}
      </Typography>
      <FormikArray
        addItemLabel={t('buttons.add_rule')}
        name="payinBlockAmountConfigs"
        removable
        defaultValue={{ period: '', count: '', duration: '' }}
        ItemComponent={renderItemComponent}
      />
    </Fragment>
  );
};
